<template>
  <div
    class="building-model-scroll-div"
    id="building-model-scroll-div"
    >
    <!-- :style="`width: ${size_factor * 100}%; height: ${size_factor * 100}%`" -->
    <div
      class="project-structure-building-model"
      id="project-structure-building-model"
      :style="`left: calc(${model_offset.x}px + 50%); top: calc(${model_offset.y}px + 50%)`"
      >
      <slot/>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['model_offset'],
    data: () => ({
      // size_factor: 2,
    }),
    // mounted() {
    //   let el = document.getElementById('scroll-div')
    //   el.scrollLeft = el.scrollWidth/4;
    //   el.scrollTop = el.scrollHeight/4;
    // },
    methods: {
      // test() {
      //   this.size_factor = this.size_factor + 1
      // }
    }
  }
</script>
<style>
  .building-model-scroll-div {
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
    background-color: white;
    outline: none;
  }
  .project-structure-building-model {
    position: relative;
    height: 1px;
    width: 1px;
    left: 50%;
    top: 50%;
    border: solid 1px black;
  }
</style>
